module.exports = __webpack_public_path__ + "img/nav_icon_board.1a3b8e2d.svg";